import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate } from 'react-router';
import { getNotificationsUser } from '../actions/notificationActions';
// import Swal from 'sweetalert2';
import { listOrders } from '../actions/orderActions';
// import { deleteOrder, listOrders } from '../actions/orderActions';
import { AlertMessage } from '../components/AlertMessage';
import { CustomDataTable } from '../components/CustomDataTable';
import { LoadingBox } from '../components/LoadingBox';
import { ToolBar } from '../components/ToolBar';
import { ORDER_DELETE_RESET } from '../constants/orderConstants';

export const OrderListScreen = () => {
    const navigate = useNavigate();
    const orderList = useSelector(state => state.orderList);
    const {loading, error, orders} = orderList;

    const [ordersFiltered, setOrdersFiltered] = useState([])
    const [minDate, setMinDate] = useState('')
    const [maxDate, setMaxDate] = useState('')

    const orderDelete = useSelector(state => state.orderDelete)    
    const { loading: loadingDelete, success: successDelete, error: errorDelete} = orderDelete;

    const dispatch = useDispatch();

    // const deleteHandler = (order) => {
    //     Swal.fire({
    //         title: `Se va a eliminar el pedido, ¿Estas seguro?`,
    //         showDenyButton: false,
    //         showCancelButton: true,
    //         confirmButtonText: 'Si',
    //         denyButtonText: 'No', 
    //         cancelButtonText: "Cancelar",
    //         icon: "warning",           
    //       }).then((result) => {
    //         if (result.isConfirmed) {
    //             dispatch(deleteOrder(order._id));
    //           Swal.fire('Pedido eliminado', '', 'success')
    //         } else if (result.isDenied) {
    //           Swal.fire('Changes are not saved', '', 'info')
    //         }
    //       })
    // }


    const columns = [
        {          
          name: 'REFERENCIA',
          cell: row => <span>{row.orderReference}</span>,
          selector: (row) => row.orderReference,
          sortable: true,          
        },
        {
          name: "CLIENTE",
          selector: (row) => row.user?.name,
          sortable: true,
          cell: (row) => <span>{row.user?.name}</span>,
        },
        {
          name: "FECHA",
          cell: row => <span>{row.createdAt.substring(0, 10)}</span>,
          selector: (row) => row.createdAt.substring(0, 10),
          sortable: true,
          right: true
        },
        {
          name: "TOTAL",
          selector: (row) => row.totalPrice,
          sortable: true,
          right: true,
          cell: (row) => <span>{row.totalPrice.toFixed(2)} €</span>,
        },
        {
          name: "PRODUCTOS",
          selector: (row) => row.orderItems.map((i, k) => (<div className='mb-1' key={k}>{i.name}</div>)),
          sortable: true,
          right: true,
          cell: (row) => <div>{row.orderItems.map((i, k) => (<div className='mb-1' key={k}>{i.name}</div>))}</div>,
        },
        {
          name: "¿PAGADO?",
          cell: row => <span>{row.isPaid ? row.paidAt?.substring(0, 10): 'No'}</span>,
          sortable: true,
          right: true,
          selector: (row) => row.isPaid ? row.paidAt?.substring(0, 10) || '': 'No',
        },  
        {
          name: "MÉTODO DE PAGO",
          selector: (row) => row.isPaid ? row.paymentMethod: '-',
          sortable: true,
          right: true,    
          cell: (row) => <span>{row.isPaid ? row.paymentMethod: '-'}</span>,
        },
        {
          name: "",
          cell: row => 
            <div className="row">
                <div className="col-12">
                <i className="bi bi-eye-fill px-2" onClick={() => { navigate(`/order/${row._id}`); }} style={{fontSize: '1.4rem', cursor: 'pointer'}}></i>                
                </div>
            </div>,
            // <div className="dropdown dropup">
            //     <button className="btn btn-sm btn-light btn-active-light-primary" type="button" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
            //         Acciones
            //         <span className="svg-icon svg-icon-5 m-0">
            //             <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            //                 <path d="M11.4343 12.7344L7.25 8.55005C6.83579 8.13583 6.16421 8.13584 5.75 8.55005C5.33579 8.96426 5.33579 9.63583 5.75 10.05L11.2929 15.5929C11.6834 15.9835 12.3166 15.9835 12.7071 15.5929L18.25 10.05C18.6642 9.63584 18.6642 8.96426 18.25 8.55005C17.8358 8.13584 17.1642 8.13584 16.75 8.55005L12.5657 12.7344C12.2533 13.0468 11.7467 13.0468 11.4343 12.7344Z" fill="black" />
            //             </svg>
            //         </span> 
            //     </button>
            //     <ul className="dropdown-menu menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4" aria-labelledby="dropdownMenuButton1">
            //         <li className="menu-item px-3"><button className="dropdown-item menu-link px-3" onClick={() => { navigate(`/order/${row._id}`); }} >Detalles</button></li>
            //     </ul>
            // </div>,
          center: true,
        }
      ];

      useEffect(() => {
        dispatch({ type: ORDER_DELETE_RESET});
        dispatch(listOrders());
        dispatch(getNotificationsUser());
    }, [dispatch, successDelete])

    useEffect(() => {
      setOrdersFiltered(orders)
    }, [orders])

    useEffect(() => {
      let ordersCopy = orders
      if (minDate.trim() !== '') {
        ordersCopy = ordersCopy?.filter(o => new Date(o.paidAt) >= new Date(minDate))
      }
      if (maxDate.trim() !== '') {
        let dateObj = new Date(maxDate)
        ordersCopy = ordersCopy?.filter(o => new Date(o.paidAt) <= dateObj.setDate(dateObj.getDate() + 1))
      }
      setOrdersFiltered(ordersCopy || [])
    }, [minDate, maxDate, orders])

    return (
    <>
    <ToolBar titulo={"Pedidos"} hitos={[
        {titulo: "Inicio", enlace: "/" },
        {titulo: "Pedidos", enlace: "#" }]}/>
    <div id="kt_content_container" className="d-flex flex-column-fluid align-items-start container-xxl">
      <div className="content flex-row-fluid" id="kt_content">        
        <div className="card card-flush">
            <div className="card-body">
              <div className='row mb-6'>
                <div className='col-6'>
                  <label className='text-muted'>Fecha de comienzo</label>
                  <input className='form-control' type="date" name='minDate' value={minDate} onChange={(e) => {setMinDate(e.target.value)}}/>
                </div>
                <div className='col-6'>
                  <label className='text-muted'>Fecha de fin</label>
                  <input className='form-control' type="date" name='maxDate' value={maxDate} onChange={(e) => {setMaxDate(e.target.value)}}/>
                </div>
              </div>
            {loadingDelete && (
                <LoadingBox variant={"primary"}/>
            )}
            {errorDelete && (
                <AlertMessage variant={"danger"} message={errorDelete}/>
            )}
            { loading ?  
                <LoadingBox variant={"primary"}/> : 
            error? 
                <AlertMessage variant={"danger"} message={error}/> : 
            (      
                <CustomDataTable data={ordersFiltered} columns={columns}/>
            )
            }
            </div>
        </div>
      </div>
    </div>
    </>
    )
}
